export const setFileName = (fileName) => {
  if(fileName && fileName.toLowerCase().endsWith('.heic')) {
    let name = fileName.toLowerCase().split('.heic');
    name = `${name[0]}.jpeg`;
    return name;
  }

  return fileName;
}
